<template>
  <v-container grid-list-md text-xs-center>
    <TabClassSchedule />
    <Table />
    <CourseDetial />
  </v-container>
</template>

<script>
import TabClassSchedule from "../components/Tabs/TabClassSchedule";
import Table from "../components/Table";
import CourseDetial from "../components/CourseDetial";

export default {
  components: {
    TabClassSchedule,
    Table,
    CourseDetial,
  },
  mounted() {
    this.$store.commit("clearInfo");
  },
};
</script>
